import { useAuth } from "../context/auth";
import { Microsoft } from "@mui/icons-material";
import ZownIcon from "../assets/zown-logo-white-wide.svg";
import { Modal, Box, Typography, Button } from "@mui/material";

export const LoginModal = () => {
  const { isAuthenticated, login } = useAuth();

  return (
    <Modal open={!isAuthenticated} aria-labelledby="login-popup">
      <Box
        sx={{
          p: 4,
          width: 350,
          top: "50%",
          left: "50%",
          boxShadow: 24,
          borderRadius: 2,
          textAlign: "center",
          position: "absolute",
          bgcolor: "background.paper",
          transform: "translate(-50%, -50%)"
        }}
      >
        <img src={ZownIcon} alt="" style={{ width: "100px" }} />
        <Typography variant="h6" component="h2" mb={2} color="primary">
          Log In
        </Typography>
        <Typography variant="body2" mb={3}>
          Please log in to access this resource.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          fullWidth
          sx={{ mb: 2 }}
          onClick={login}
          startIcon={<Microsoft />}
        >
          Log In
        </Button>
      </Box>
    </Modal>
  );
};
